"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultViewControlRules = exports.getInvalidFieldViewControlRules = void 0;
const mapValues_1 = __importDefault(require("lodash-es/mapValues"));
/**
 * Return a new ViewControlRules object containing the default rules for an invalid field.
 * All rules are disabled except `fieldInFieldsToDisplay`.
 */
const getInvalidFieldViewControlRules = () => {
    return {
        ...(0, mapValues_1.default)((0, exports.getDefaultViewControlRules)(), () => "disable"),
        fieldInFieldsToDisplay: "show",
        groupBy: { direction: "asc" },
    };
};
exports.getInvalidFieldViewControlRules = getInvalidFieldViewControlRules;
/**
 * Return a new ViewControlRules object containing the default rules for a field.
 */
const getDefaultViewControlRules = () => ({
    fieldInFieldsToDisplay: "show",
    nestedFieldsInFieldsToDisplay: "show",
    fieldInSort: "show",
    nestedFieldsInSort: "show",
    fieldInFilter: "show",
    nestedFieldsInFilter: "show",
    fieldInGroup: "show",
    nestedFieldsInGroup: "show",
    fieldInSpotlight: "show",
    nestedFieldsInSpotlight: "show",
    disableFieldInTextSearch: "show",
    groupBy: { direction: "asc" },
});
exports.getDefaultViewControlRules = getDefaultViewControlRules;
